// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"198b6374","153":"56f1a241","181":"2998aa01","272":"c4eb59e9","559":"5bc6728d","893":"b87b3876"}[chunkId] + ".chunk.css";
};